import * as DEPLOYMENT_MESSAGE from 'constant/deployment-messages'
import moment from 'moment'

export default function formatDeployTime () {
  const dateISO = process.env.DEPLOY_TIME

  if (typeof dateISO === 'string') {
    const date = new Date(dateISO).toUTCString()
    return moment(date).format('ddd, Do MMM yyyy  kk:mm')
  }

  return DEPLOYMENT_MESSAGE.TIME_FALLBACK
}
